import script from "./LobbyingView.vue?vue&type=script&setup=true&lang=js"
export * from "./LobbyingView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__